import { FC } from 'react';

import { PopupCountyInfoProps, PopupCountyInfoValue } from './PopupCountyInfo.types';
import { StyledContainer, StyledInfoItem, StyledLabel, StyledValue } from './PopupCountyInfo.styles';

const PopupCountyInfo: FC<PopupCountyInfoProps> = ({ info }) => {
  return (
    <StyledContainer>
      {info?.map((i: PopupCountyInfoValue, key: number) => {
        return (
          <StyledInfoItem key={key}>
            <StyledLabel data-testid={`${i.id}-label`}>{i.label}</StyledLabel>
            <StyledValue data-testid={`${i.id}-value`}>{i.value}</StyledValue>
          </StyledInfoItem>
        );
      })}
    </StyledContainer>
  );
};

export default PopupCountyInfo;
